import { MainApi } from "./MainApi";
import { CountryReportPolicyPostParam } from "../types/countryReportPolicy";

export class CountryReportPolicyApi {
  static baseUrl = `${MainApi.urlPrefix}/country-report-policies`;

  // 정책 목록 조회
  static getPolicies = () => () => MainApi.api.get(CountryReportPolicyApi.baseUrl);

  // 정책 단건 조회
  static getPolicy = (idx: number) => () => MainApi.api.get(`${CountryReportPolicyApi.baseUrl}/${idx}`);

  // 정책 등록
  static createPolicy = (param: CountryReportPolicyPostParam) => () =>
    MainApi.api.post(CountryReportPolicyApi.baseUrl, param);

  // 정책 수정
  static updatePolicy = (idx: number, param: CountryReportPolicyPostParam) => () =>
    MainApi.api.put(`${CountryReportPolicyApi.baseUrl}/${idx}`, param);

  // 정책 삭제
  static deletePolicy = (idx: number) => () => MainApi.api.delete(`${CountryReportPolicyApi.baseUrl}/${idx}`);
}
